import TeamsComponent from '../TeamsComponent.vue'

export default [
    {
        path: '/teams',
        name: 'Teams',
        meta: { layout: 'default' },
        component: TeamsComponent,
    },
]
